import React from 'react';
import ReactPlaceholder from 'react-placeholder';
import { BuildingSummaryHealthStatus } from '../../../models/buildingModels';
import offlineTablePlaceholder from '../../status/buildingStatus/components/OfflineTablePlaceholder';
import CustomerStatusBuildingsTable from './CustomerStatusBuildingsTable';
import styles from './PartnerDesktopTable.module.scss';

type Props = {
    offlineLocations: BuildingSummaryHealthStatus[];
    partnerManagedUserGroupId?: string;
};

const ExpandedCustomerRow = ({ offlineLocations, partnerManagedUserGroupId }: Props): React.ReactElement => {
    return (
        <div className={styles.expandedRowWrapper}>
            <div className={styles.expandedRow}>
                <ReactPlaceholder ready={!!offlineLocations} customPlaceholder={offlineTablePlaceholder}>
                    <div style={{ order: offlineLocations.length === 0 ? 1 : 0 }}>
                        <CustomerStatusBuildingsTable
                            offlineBuildings={offlineLocations || []}
                            darkHeader
                            partnerManagedUserGroupId={partnerManagedUserGroupId || ''}
                        />
                    </div>
                </ReactPlaceholder>
            </div>
        </div>
    );
};

export default ExpandedCustomerRow;
